import { ModuleWithProviders } from "@angular/core";
import { Routes, RouterModule } from "@angular/router";

import { AuthGuard } from "@atenea-cms";
import { SerieListComponent } from "./serie-list/serie-list.component";

const routes: Routes = [
  {
    path: "series",
    component: SerieListComponent,
    canActivate: [AuthGuard],
  },
];

export const SeriesRoutes: ModuleWithProviders = RouterModule.forChild(routes);



// WEBPACK FOOTER //
// ./libs/atenea-cms-brand/src/series/series.routes.ts